'use client';

export { default } from './StyledEngineProvider';


//////////////////
// WEBPACK FOOTER
// ../@mui/styled-engine/StyledEngineProvider/index.js
// module id = 1698
// module chunks = 25